import { useMutation } from "@tanstack/react-query";
import { createTeacher as apiCreate } from "../../api/apiTeachers";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateTeacher() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { mutate: createTeacher, isPending, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/teachers'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { isPending, error, createTeacher };
}
